import { render, staticRenderFns } from "./poster-v2.vue?vue&type=template&id=70a6597d&scoped=true"
import script from "./poster-v2.vue?vue&type=script&lang=js"
export * from "./poster-v2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a6597d",
  null
  
)

export default component.exports